const state = {
  chooseRoleFiles: [{}],
  onwerAllRoleList: [{}], // 拥有的角色信息list
  curSelectRoleInfo: {},
  curDigitalInfo: {},
  showLeftSlide: false,
  showRightSlide: false,
  is_show_chat_toolltip: false,
  showAvatar: true,
  isCurChatFinshed: true
}
const mutations = {
  setChooseRoleFiles(state: any, data: any) {
    state.chooseRoleFiles = data
  },
  setonwerAllRoleList(state: any, data: any) {
    state.onwerAllRoleList = data
  },
  setCurSelectRoleInfo(state: any, data: any) {
    state.curSelectRoleInfo = data
  },
  setCurDigitalInfo(state: any, data: any) {
    state.curDigitalInfo = data
  },
  setShowLeftSlide(state: any, data: any) {
    state.showLeftSlide = data
  },
  setShowRightSlide(state: any, data: any) {
    state.showRightSlide = data
  },
  set_is_show_chat_toolltip(state: any, data: any) {
    state.is_show_chat_toolltip = data
  },
  setShowAvatar(state: any, data: any) {
    state.showAvatar = data
  },
  setIsCurChatFinshed(state: any, data: any) {
    state.isCurChatFinshed = data
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
